<div>
  <div class="hotel-deals-container ion-padding" *ngIf="deals?.length > 0">
    <!-- Header -->
    <div class="header marb10">
      <ion-label class="fs-5 font700 title-text-color"
        >Top Hotel Deals</ion-label
      >
      <ion-button class="clear-btn ion-no-margin" (click)="goToAllDeals()">
        View All
      </ion-button>
    </div>

    <!-- Deals Cards -->
    <div class="deals-wrapper">
      <ion-card
        *ngFor="let deal of deals"
        class="deal-card"
        (click)="onDealClick(deal)"
      >
        <ion-card-content class="ion-no-padding pad10">
          <div class="card-content">
            <div class="text-content">
              <h3 class="fs-2 font700 title-text-color line-2-clip title">
                {{ deal.title }}
              </h3>
              <p class="fs-1 font700 mart4 green-text-color line-1-clip subtitle">
                {{ deal.subTitle }}
              </p>
              <div class="mart4 arrow-button" (click)="onDealClick(deal)">
                <ion-icon name="chevron-forward"></ion-icon>
              </div>
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </div>
  </div>
  <ion-card class="search-container grey-border">
    <ion-list
      class="input-container ion-padding-top ion-list-transparent-bg-color"
    >
      <ion-item
        lines="none"
        class="ion-margin-bottom ion-item-transparent-bg-color {{
          showValidationErrors && !selectedSearchObject?.entityId
            ? 'red-border'
            : ''
        }}"
        (click)="presentCityHotelSearchModal()"
      >
        <ion-label class="ion-text-wrap">
          {{
            selectedSearchObject?.label ||
              selectedSearchObject?.entityId ||
              ("hotel.hotel_search.city_or_name*" | translate)
          }}
        </ion-label>
        <ion-icon
          slot="end"
          name="search-outline"
          class="primary-icon-color"
        ></ion-icon>
      </ion-item>
      <ion-grid class="ion-no-padding ion-no-margin" fixed>
        <ion-row>
          <ion-col size="6">
            <ion-item
              lines="none"
              class="ion-margin-bottom ion-margin-end ion-item-transparent-bg-color"
            >
              <ion-label
                position="stacked"
                fill="outline"
                class="ion-label-grey-text-color"
                >{{ "hotel.hotel_search.check_in_date" | translate }}</ion-label
              >
              <ion-input
                type="date"
                [min]="minDateAllowed"
                max="9999-12-31"
                [(ngModel)]="checkInDate"
                aria-label="checkInDate"
                placeholder="{{
                  'hotel.hotel_search.check_in_date' | translate
                }}"
                (ionChange)="updateCheckoutDate()"
                (click)="datePicker()"
              >
                <!-- <div slot="label">
                  {{'hotel.hotel_search.check_in_date' | translate}}
                </div> -->
              </ion-input>
            </ion-item>
          </ion-col>
          <ion-col size="6">
            <ion-item
              lines="none"
              class="ion-margin-bottom ion-item-transparent-bg-color"
            >
              <ion-label position="stacked" class="ion-label-grey-text-color">{{
                "hotel.hotel_search.check_out_date" | translate
              }}</ion-label>
              <ion-input
                type="date"
                aria-label="checkOutDate"
                [min]="checkInDate ? calculateMinDate() : minDateAllowed"
                max="9999-12-31"
                [(ngModel)]="checkOutDate"
                (ionChange)="onCheckoutDateChange()"
                placeholder="{{
                  'hotel.hotel_search.check_out_date' | translate
                }}"
                (click)="datePicker()"
              ></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-grid>
      <ion-item
        lines="none"
        class="ion-margin-bottom ion-item-transparent-bg-color"
        (click)="presentRoomSelectionModal()"
      >
        <ion-label class="ion-text-wrap">
          {{
            getRoomString() || ("hotel.hotel_search.select_rooms" | translate)
          }}
        </ion-label>
        <ion-icon
          slot="end"
          name="chevron-down-outline"
          class="primary-icon-color"
        ></ion-icon>
      </ion-item>
    </ion-list>

    <div class="ion-padding">
      <ion-button
        type="submit"
        mode="ios"
        class="fs-4 font600 primary-btn marb10"
        expand="block"
        [disabled]="!isFormValid"
        (click)="submitSearchQuery()"
      >
        {{ "hotel.hotel_search.search_btn" | translate }}
      </ion-button>
    </div>
  </ion-card>
</div>
